import type { useInterventionFollowupDropDownProps } from "@/modules/intervention/intervention-followup/intervention-followup-dropdown/intervention-followup-dropdown.type";
import type { MenuProps } from "antd";
import type { ReactNode } from "react";

import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { ModelLink } from "@/modules/model-link";

import { InterventionFollowupDropdownPopup } from "../intervention-followup-dropdown-popup";

export const useInterventionFollowupDropDown = ({
  intervention,
}: useInterventionFollowupDropDownProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const versions = intervention.followup?.versions;
  const menuItems: MenuProps["items"] = useMemo(() => {
    return versions?.map((version) => ({
      key: `version-${version.id}`,
      label: (
        <ModelLink
          model="intervention"
          item={version}
          search={`${location.search}`}
          key={`version-link-${version.id}`}
        >
          {version.name}
        </ModelLink>
      ),
    }));
  }, [versions, location.search]);

  const renderPopup = useCallback(
    (menu: ReactNode) => (
      <InterventionFollowupDropdownPopup
        intervention={intervention}
        menu={menu}
      />
    ),
    [intervention]
  );

  return {
    label: t("followUp:button.label"),
    menuItems,
    renderPopup,
  };
};
